import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Sidebar from "./components/Sidebar";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { POList } from "./pages/POList";
import { PONew } from "./pages/PONew";
import { DispatchNew } from "./pages/DispatchNew";
import { Reports } from "./pages/Reports";
import { BuyerMaster } from "./pages/BuyerMaster";
import UserManagement from "./pages/UserManagement";
import Production from "./pages/Production";
import JobWorkers from "./pages/JobWorkers";
import JobCards from "./pages/JobCards";
import WagesMaster from "./pages/WagesMaster";
import Wages from "./pages/Wages";
import { Toaster } from "./components/ui/sonner";

function AppLayout({ children }) {
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/po/list"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <POList />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/po/new"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <PONew />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dispatch/new"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <DispatchNew />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Reports />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/buyers"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <BuyerMaster />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AppLayout>
                  <UserManagement />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/production"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager', 'supervisor', 'data_entry']}>
                <AppLayout>
                  <Production />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-cards"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager', 'supervisor', 'data_entry']}>
                <AppLayout>
                  <JobCards />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-workers"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager', 'supervisor', 'data_entry']}>
                <AppLayout>
                  <JobWorkers />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/wages-master"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager', 'data_entry']}>
                <AppLayout>
                  <WagesMaster />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/wages"
            element={
              <ProtectedRoute allowedRoles={['admin', 'manager', 'data_entry']}>
                <AppLayout>
                  <Wages />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
